import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-main" }
const _hoisted_3 = {
  class: "login-card",
  "aria-labelledby": "loginTitle"
}
const _hoisted_4 = {
  key: 0,
  class: "login-alert",
  role: "alert"
}
const _hoisted_5 = { class: "login-field" }
const _hoisted_6 = { class: "login-input" }
const _hoisted_7 = { class: "login-field" }
const _hoisted_8 = { class: "login-input" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { class: "login-options" }
const _hoisted_11 = {
  class: "login-remember",
  for: "rememberMe"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "login-field" }
const _hoisted_16 = { class: "login-input" }
const _hoisted_17 = {
  key: 0,
  class: "forgot-password-feedback forgot-password-feedback--error"
}
const _hoisted_18 = {
  key: 1,
  class: "forgot-password-feedback forgot-password-feedback--success"
}
const _hoisted_19 = { class: "forgot-password-actions" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueInputText = _resolveComponent("PrimevueInputText")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"login-page__shade\" data-v-6b05aab0></div><aside class=\"login-benefits\" aria-label=\"Avantages Suite241 Gestion Commerciale\" data-v-6b05aab0><article class=\"login-benefit\" data-v-6b05aab0><span class=\"login-benefit__icon\" data-v-6b05aab0><i class=\"fa fa-box-open\" data-v-6b05aab0></i></span><div data-v-6b05aab0><h2 data-v-6b05aab0>Stock en temps réel</h2><p data-v-6b05aab0>Suivez chaque mouvement de vos produits.</p></div></article><article class=\"login-benefit\" data-v-6b05aab0><span class=\"login-benefit__icon\" data-v-6b05aab0><i class=\"fa fa-chart-simple\" data-v-6b05aab0></i></span><div data-v-6b05aab0><h2 data-v-6b05aab0>Rapports et analyses</h2><p data-v-6b05aab0>Prenez les bonnes décisions grâce à des rapports clairs.</p></div></article><article class=\"login-benefit\" data-v-6b05aab0><span class=\"login-benefit__icon\" data-v-6b05aab0><i class=\"fa fa-shield-halved\" data-v-6b05aab0></i></span><div data-v-6b05aab0><h2 data-v-6b05aab0>Sécurisé et fiable</h2><p data-v-6b05aab0>Vos données sont protégées et sauvegardées.</p></div></article></aside>", 2)),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("header", { class: "login-card__header" }, [
          _createElementVNode("img", {
            class: "login-logo",
            src: _imports_0,
            alt: "Suite241 Gestion Commerciale"
          })
        ], -1)),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "login-card__welcome" }, [
          _createElementVNode("h1", { id: "loginTitle" }, "Bienvenue !"),
          _createElementVNode("p", null, "Connectez-vous pour accéder à votre espace")
        ], -1)),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          class: "login-form",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "username" }, "Nom d'utilisateur ou email", -1)),
            _createElementVNode("span", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa fa-user" }, null, -1)),
              _createVNode(_component_PrimevueInputText, {
                id: "username",
                modelValue: _ctx.form.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
                type: "text",
                autocomplete: "username",
                placeholder: "Entrez votre email ou nom d'utilisateur",
                required: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "password" }, "Mot de passe", -1)),
            _createElementVNode("span", _hoisted_8, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-lock" }, null, -1)),
              _createVNode(_component_PrimevueInputText, {
                id: "password",
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                type: _ctx.showPassword ? 'text' : 'password',
                autocomplete: "current-password",
                placeholder: "Entrez votre mot de passe",
                required: ""
              }, null, 8, ["modelValue", "type"]),
              _createElementVNode("button", {
                type: "button",
                class: "login-password-toggle",
                "aria-label": _ctx.showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa", _ctx.showPassword ? 'fa-eye-slash' : 'fa-eye'])
                }, null, 2)
              ], 8, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              _createVNode(_component_PrimevueCheckbox, {
                id: "rememberMe",
                modelValue: _ctx.rememberMe,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rememberMe) = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "Se souvenir de moi", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "login-forgot-link",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openForgotPasswordDialog && _ctx.openForgotPasswordDialog(...args)))
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("i", {
                class: "fa fa-key me-1",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" Mot de passe oublié ? ", -1)
            ]))])
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "login-submit",
            disabled: _ctx.isLoading
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fa", _ctx.isLoading ? 'fa-spinner fa-spin' : 'fa-right-to-bracket'])
            }, null, 2),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Connexion..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, "Se connecter"))
          ], 8, _hoisted_12)
        ], 32)
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("p", { class: "login-copyright" }, "© 2024 Suite241 Gestion Commerciale. Tous droits réservés.", -1)),
    _createVNode(_component_PrimevueDialog, {
      visible: _ctx.forgotPasswordDialogVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.forgotPasswordDialogVisible) = $event)),
      header: "Mot de passe oublié",
      modal: "",
      draggable: false,
      style: { width: 'min(92vw, 430px)' },
      class: "forgot-password-dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "forgot-password-form",
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForgotPassword && _ctx.submitForgotPassword(...args)), ["prevent"]))
        }, [
          _cache[21] || (_cache[21] = _createElementVNode("p", null, " Entrez l'adresse email enregistrée sur votre compte. Si elle existe et que le compte est actif, vous recevrez un lien pour choisir un nouveau mot de passe. ", -1)),
          _createElementVNode("div", _hoisted_15, [
            _cache[19] || (_cache[19] = _createElementVNode("label", { for: "forgotPasswordEmail" }, "Adresse email du compte", -1)),
            _createElementVNode("span", _hoisted_16, [
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa fa-envelope" }, null, -1)),
              _createVNode(_component_PrimevueInputText, {
                id: "forgotPasswordEmail",
                modelValue: _ctx.forgotPasswordEmail,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.forgotPasswordEmail) = $event)),
                type: "email",
                autocomplete: "email",
                placeholder: "exemple@domaine.com",
                required: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_ctx.forgotPasswordError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.forgotPasswordError), 1))
            : _createCommentVNode("", true),
          (_ctx.forgotPasswordMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.forgotPasswordMessage), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              disabled: _ctx.isRequestingPasswordReset,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.forgotPasswordDialogVisible = false))
            }, [...(_cache[20] || (_cache[20] = [
              _createElementVNode("i", {
                class: "fa fa-xmark me-1",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" Annuler ", -1)
            ]))], 8, _hoisted_20),
            _createElementVNode("button", {
              type: "submit",
              class: "login-submit forgot-password-submit",
              disabled: _ctx.isRequestingPasswordReset
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa", _ctx.isRequestingPasswordReset ? 'fa-spinner fa-spin' : 'fa-paper-plane'])
              }, null, 2),
              (_ctx.isRequestingPasswordReset)
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Envoi..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_23, "Envoyer"))
            ], 8, _hoisted_21)
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}